import { render, staticRenderFns } from "./SalesProductModal.vue?vue&type=template&id=292d5156"
import script from "./SalesProductModal.vue?vue&type=script&lang=js"
export * from "./SalesProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports